import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020double/controller.php?enews=';

interface IVoteListOption {
  page?: number;
}
export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};
// 最新资讯
export const getNow = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}now`, {
    params: { page },
  });
};

// 区县长带货直播
export const getLive = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}live`, {
    params: { page },
  });
};

// 文旅精品90秒
export const getBoutique = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}boutique`, {
    params: { page },
  });
};

// 区县文旅精品荟
export const getAreaBoutique = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}area-boutique`, {
    params: { page },
  });
};
// 区长、县长带货来
export const getCarrying = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}carrying`, {
    params: { page },
  });
};
